import { UserContext } from "@context/user";
import { confirmAlert } from "@helpers/toast";
import { destroyUserSession, getItemFromStore } from "@helpers/utils";
import themeConfig from "@configs/theme-config";
import axios from "axios";
import { useContext } from "react";

const useLogout = () => {
  const { handleUserData } = useContext(UserContext);

  const handleAuthLogout = async () => {
    // Call backend logout API (best-effort, don't block on failure)
    try {
      const userInfo = getItemFromStore("userInfo") || {};
      const user = userInfo.user || {};
      if (user.email && user.orgName) {
        await axios.post(
          `${themeConfig.apiUrl.base}/admin/logout`,
          { email: user.email, orgName: user.orgName },
          { headers: { Authorization: `Bearer ${getItemFromStore("token")}` } }
        );
      }
    } catch {
      // Ignore logout API errors — clear local state regardless
    }

    handleUserData();
    destroyUserSession();
    window.location.pathname = "/login";
  };

  const handleLogout = async () => {
    await confirmAlert({
      title      : "Confirm Logout",
      text       : "Are you sure you want to log out?",
      imageHeight: 100,
      preConfirm : () => {
        handleAuthLogout();
      }
    });
  };

  return {
    handleLogout,
    handleAuthLogout
  };
};

export default useLogout;
